export default __webpack_public_path__ + "static/media/icn-speed-vehicle.d3bd09f7.svg";